import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const AstaxanthinStats = ({ name }) => {
  switch (name) {
    case "almond":
      return (
        <div className="stat px-6 pt-2 md:p-0">
          <h4
            className="text-white"
            style={{ fontSize: "20px", lineHeight: "20px" }}
          >
            110x
          </h4>
          <p className="text-gray-lighter text-sm mb-1">
            Stronger than Vitamin E
          </p>
          <div className="flex items-center mb-4">
            <StaticImage
              src="../../images/youBeauty/almond-icon.png"
              alt="almond"
              width={55}
            />
            <div className="barGraph red -ml-4" style={{ width: "20px" }}></div>
          </div>
        </div>
      );
    case "tea":
      return (
        <div className="stat px-6 pt-2 md:p-0">
          <h4
            className="text-white"
            style={{ fontSize: "22px", lineHeight: "22px" }}
          >
            560x
          </h4>
          <p className="text-gray-lighter text-sm mb-1">
            Stronger than Green tea catechins
          </p>
          <div className="flex items-center mb-4">
            <StaticImage
              src="../../images/youBeauty/green-tea-icon.png"
              alt="tea leaves"
              width={55}
            />
            <div className="barGraph red -ml-4" style={{ width: "9%" }}></div>
          </div>
        </div>
      );
    case "peach":
      return (
        <div className="stat px-6 pt-2 md:p-0">
          <h4
            className="text-white"
            style={{ fontSize: "24px", lineHeight: "24px" }}
          >
            800x
          </h4>
          <p className="text-gray-lighter text-sm mb-1">Stronger than CoQ 10</p>
          <div className="flex items-center mb-4">
            <StaticImage
              src="../../images/youBeauty/peach-icon.png"
              alt="peach"
              width={45}
            />
            <div className="barGraph red -ml-4" style={{ width: "15%" }}></div>
          </div>
        </div>
      );
    case "grape":
      return (
        <div className="stat px-6 pt-2 md:p-0">
          <h4
            className="text-white"
            style={{ fontSize: "28px", lineHeight: "28px" }}
          >
            3000x
          </h4>
          <p className="text-gray-lighter text-sm mb-1">
            Stronger than Resveratrol
          </p>
          <div className="flex items-center mb-4">
            <StaticImage
              src="../../images/youBeauty/grape-icon.png"
              alt="grapes"
              width={55}
              className="-mt-1"
            />
            <div className="barGraph red -ml-4" style={{ width: "48%" }}></div>
          </div>
        </div>
      );
    case "orange":
      return (
        <div className="stat px-6 pt-2 md:p-0">
          <h4
            className="text-white"
            style={{ fontSize: "35px", lineHeight: "35px" }}
          >
            6000x
          </h4>
          <p className="text-gray-lighter text-sm mb-1">
            Stronger than Vitamin C
          </p>
          <div className="flex items-center mb-4">
            <StaticImage
              src="../../images/youBeauty/orange-icon.png"
              alt="orange"
              width={50}
            />
            <div className="barGraph red -ml-4" style={{ width: "100%" }}></div>
          </div>
        </div>
      );
    default:
      return;
  }
};

export default AstaxanthinStats;
